import React, { Component } from 'react';

// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {Button, Card} from '@betareader/design-system';

import moment from 'moment';

import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import { toast } from 'react-toastify';

import { getFreshIdToken } from '../../utils/authUtil';


import queryString from 'query-string';

export class ReadathonIndex extends Component {
  constructor(props) {
    super(props);
    const parsedQueryString = queryString.parse(props.location.search);
    this.state = { parsedQueryString };
  }

  componentDidMount() {
    // code to handle case when old acceptinvitation was redirected to discover without a bookId
    // this.fetchReadathonStatus();
  }

  fetchReadathonStatus = async () => {
    const { t } = this.props;
    const idToken = await getFreshIdToken();
    fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/readathon`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'br-token': idToken
      }
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        return res.json().then((json) => {
          const error = new Error(json.msg || res.statusText)
          error.response = res;
          // add book if we get it in the response so we can show proper error message
          if (json.book) {
            error.book = json.book;
          }
          throw error;
        });
      })
      .then(({ current, finished }) => {
        this.setState({
          current, finished
        });
      })
      .catch((err) => {
        toast.info(t(err));
      });
  }

  render() {
    const {t, userProfile} = this.props;
    const {current, finished} = this.state;
    return (
      <main className='br-text font-size-normal'
        style={{maxWidth: 960, margin: '0 auto', padding: '1.5rem'}}>
        <img src='/assets/images/readathon-logo.png' alt='Readathon'
          style={{display: 'block', maxWidth: '100%', margin: '0 auto'}} />
        <h1>{t('ReadathonHasEnded')}</h1>
        <p>{t('ReadathonInfo')}</p>
        <ul>
          <li>{t('ReadathonPrize1')}</li>
          <li>{t('ReadathonPrize23')}</li>
        </ul>
        {!userProfile && (
          <section>
            <h2>{t('SignInToJoin')}</h2>
            <Button onClick={() => this.props.changePage('/signup?redirect=/readathon')}>
              {t('SignIn')}
            </Button>
          </section>
        )}
        {finished && (
          <>
            <dl style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem'}}>
              {finished.books?.length > 0 && (
                <div><dt>{t('WordsReviewedByYou')}</dt>
                  <dd>{finished.words ? finished.words.toLocaleString() : t('N/A')}</dd></div>
              )}
              <div><dt>{t('WordsReviewedByEveryone')}</dt>
                <dd>{finished.wordsTotal ? finished.wordsTotal.toLocaleString() : t('N/A')}</dd></div>
            </dl>
            <Card style={{padding: '1rem'}}>
              <h2>{t('Status')}</h2>
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '1.5rem'}}>
                <section>
                  <h3>{t('Completed')}</h3>
                  <ul>
                    {finished.books?.map(book => (
                      <li key={book._id}>
                        <Button variant='ghost' size='small'
                          onClick={() => this.props.changePage(`/read?book=${book._id}`)}>
                          {book.title} ({t('WordCountString', {count: book.words.toLocaleString()})})
                        </Button>
                        {' '}{t('CompletedAt')}: {moment(book.completedAt).format('L')}
                      </li>
                    ))}
                  </ul>
                </section>
                <section>
                  <h3>{t('CurrentlyReading')}</h3>
                  <ul>
                    {current?.books?.map(book => (
                      <li key={book._id}>
                        <Button variant='ghost' size='small'
                          onClick={() => this.props.changePage(`/discover/${book._id}`)}>
                          {book.title}
                        </Button>
                        {' '}{book.status === 'REQUESTED' ? t('Pending')
                          : `${t('Position')}: ${((book.position || 0) * 100).toFixed(0)}%`}
                      </li>
                    ))}
                  </ul>
                </section>
              </div>
            </Card>
            <Button onClick={() => this.props.changePage('/discover')}>
              {t('FindSomethingToRead')}
            </Button>
          </>
        )}
      </main>
    );
  }

}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  userProfile: state.user.userProfile,
  defaultFontSize: state.app.defaultFontSize,
  idToken: state.user.idToken
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ReadathonIndex)));
